module.exports = __webpack_public_path__ + "static/gallery-14-9d565bb4ce878913cf03453be09eacb2.jpg";